import { Empty, EmptyHeader, EmptyMedia, EmptyTitle } from '@monksflow/monks-ui';
import { EyeOffIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Shown for artifact kinds the preview modal can't render — unknown / misc /
 * custom artifacts and widget kinds whose key isn't in the registry (e.g. the
 * ideation intermediate state). A calm "not available" message rather than a
 * raw JSON dump; the modal header still shows the artifact's name. Library-only
 * (used solely by ArtifactPreviewBody).
 */
export function ArtifactPreviewFallback() {
  const { t } = useTranslation('projects');

  return (
    <Empty role="status" data-testid="artifact-preview-fallback" className="p-6 h-full">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <EyeOffIcon className="size-6 text-muted-foreground" />
        </EmptyMedia>
        <EmptyTitle>{t('projectDetail.artifactPreviewFallback.previewNotAvailable')}</EmptyTitle>
      </EmptyHeader>
    </Empty>
  );
}
